import * as qplsService from '../../../../services/Qpls/qplsService.js';
import * as daHelper from '../../../Dialogs/dialogActionsHelper';
import {dialogsNames} from '../../../../enums/dialogsNames';


const config = {
  getSubmitMethod: () => qplsService.updateMaterialsQplVersion,
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.UPDATE_MATERIAL_QPL_VERSION_DIALOG),
};

const actions = {
  ...daHelper.getActions(dialogsNames.UPDATE_MATERIAL_QPL_VERSION_DIALOG),

};

export let api = {
  ...daHelper.getApiActions(actions, config),
}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

};
